<div
  #actionButton
  #trigger="cdkOverlayOrigin"
  cdkOverlayOrigin
  data-test-id="dropdown-trigger"
  class="w-full"
  [class.pointer-events-none]="disabled"
  [class.cursor-default]="disabled"
  (click)="open()"
>
  @if (type === 'dropdown') {
    <app-dropdown-button
      [isOpen]="isOpen"
      [value]="buttonTextTranslationKey | translate: buttonTranslationKeyParams"
    ></app-dropdown-button>
  } @else {
    <app-new-button
      #menuTrigger
      [class.icon-btn]="!buttonTextTranslationKey"
      [class.open]="isOpen"
      [class.max-w-full]="truncateTrigger"
      [class]="buttonClasses"
      [type]="getButtonType()"
      [svgIconPath]="icon"
      [svgIconSizeMode]="iconMode"
      [size]="buttonSize"
      [verticalSize]="btnVerticalSize"
      [focused]="isOpen"
      [truncate]="truncateTrigger"
      [loading]="loading"
      [disabled]="disabled"
      [ngbTooltip]="tooltipTextTranslationKey | translate"
      [isOnlyIcon]="isOnlyIcon"
      [placement]="'top'"
    >
      <span class="inline-flex items-center w-full h-full">
        <span class="truncate" [class.asterisk]="required">
          {{ buttonTextTranslationKey | translate: buttonTranslationKeyParams }}
        </span>

        @if (displayArrow) {
          <svg-icon
            class="menu-icon transform w-4 h-4 ml-3 text-navy-70"
            [ngClass]="{ 'rotate-180': rotateArrow && isOpen }"
            [src]="'dropdown-arrow'"
          ></svg-icon>
        }
      </span>
    </app-new-button>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPanelClass]="'dropdown-control-overlay'"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayPositions]="overlayPosition ? [overlayPosition] : undefined"
  (backdropClick)="close()"
>
  <app-dropdown-options-backdrop
    class="{{ listWidth }}"
    [ngClass]="{ 'overflow-y-auto overflow-x-visible': backdropHeight }"
    [ngStyle]="{ 'max-height.px': backdropHeight }"
    [style.max-height.px]="backdropHeight"
    [style.min-width.px]="optionButtonsWidth"
  >
    @for (menuAction of menuActions; track $index) {
      <app-dropdown-option-with-submenu
        [attr.data-test-id]="menuAction.id"
        [menuAction]="menuAction"
        [context]="context"
        (click)="menuAction?.actAsNotAnAction ? undefined : close(); chosenAction.emit(menuAction)"
        (nestedDropdownClick)="close(); chosenAction.emit(menuAction)"
      ></app-dropdown-option-with-submenu>
    }

    @if (bottomMenuActions?.length) {
      <div class="border-t border-navy-30"></div>
      @for (menuAction of bottomMenuActions; track $index) {
        <app-dropdown-option-with-submenu
          [menuAction]="menuAction"
          [context]="context"
          (click)="close()"
        ></app-dropdown-option-with-submenu>
      }
    }
  </app-dropdown-options-backdrop>
</ng-template>
